<template>
  <v-container fluid>
    <v-toolbar class="mb-4">
      <v-toolbar-title>Features
        <v-btn icon small  color="info"
               :to="{ name: 'features-form', params: { feature_id: 0 }}"
        ><v-icon size="18">add</v-icon></v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card v-if="list.items && list.items.length">
      <v-data-table :headers="headers" :loading="inProgress" :pagination.sync="list.pagination" :total-items="list.pagination.totalItems" :items="list.items">
        <template slot="items" slot-scope="props">
          <tr>
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-right ">
              <div class="table_actions_btns">
                <v-btn icon small :to="{ name: 'features-form', params: { feature_id: props.item.id }}" color="success" :ripple="false"><v-icon size="18">edit</v-icon></v-btn>
                <remove-dialog :yes="() => remove(props.item)">
                  <v-btn color="error" icon small :ripple="false"><v-icon size="18">delete_forever</v-icon></v-btn>
                </remove-dialog>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import * as mixins from '@/mixins/'

  export default {
    name: 'FeaturesListPage',
    mixins: [mixins.removable, mixins.list, mixins.filter, mixins.preloader, mixins.user],
    data() {
      return {
        api: this.$api.features,
        headers: [
          { text: 'Title', align: 'left', sortable: true, value: 'name' },
          { text: 'Action', align: 'right', sortable: false },
        ],
      }
    },
  }
</script>
